import base from "/vercel/path0/images/instagram.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");